import { DatePipe } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'
import { Footnote } from 'src/app/models/footnote.model'

@Component({
  selector: 'characteristics-contianer',
  templateUrl: './characteristics-contianer.component.html',
  styleUrls: ['./characteristics-contianer.component.scss'],
})
export class CharacteristicsContianerComponent implements OnInit {
  @Input() portfolioModel: Portfolio
  @Input() benchmarkFootNote: Footnote
  @Input() portfolioFootNote: Footnote
  public activeTab: number
  public datePipe: DatePipe

  constructor() {
    this.datePipe = new DatePipe('en-US')
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {}

  changeTab($event) {
    this.activeTab = $event
  }
}
